import { useEffect } from "react";
import Fingerprint2 from "fingerprintjs2";
import * as Sentry from "@sentry/browser";

let deviceId = "";
let usingNativeAppId = false;

const generateDeviceId = () => new Promise((resolve) => {
	try {
		Fingerprint2.get((components) => {
			const values = components.map(({ value }) => value).join("");
			const hash = Fingerprint2.x64hash128(values, 31);
			resolve(hash);
		});
	} catch (err) {
		// Fingerprint2 does not have an error callback
		// catch just in case
		Sentry.captureException(err);
		resolve("");
	}
});

const DEVICE_ID_GENERATION_WAIT = 500;

const generateDeviceIdOnPageLoad = () => {
	// calls to Fingerprint2.get are wrapped in requestIdleCallback or a timeout
	// because the fingerprint can be unstable if it is generated right when the page loads
	const wrapper = window.requestIdleCallback
		? (cb) => window.requestIdleCallback(cb)
		: (cb) => setTimeout(cb, DEVICE_ID_GENERATION_WAIT);

	wrapper(() => {
		generateDeviceId().then((id) => {
			if (!usingNativeAppId) {
				deviceId = id;
			}

			return deviceId;
		});
	});
};

export function useDeviceFingerprint() {
	useEffect(() => {
		generateDeviceIdOnPageLoad();
	}, []);
}

export const getDeviceId = async () => {
	if (!deviceId) {
		const id = await generateDeviceId();
		return id;
	}

	return deviceId;
};

// setNativeAppDeviceId is used to overwrite the deviceid
// when native apps pass us their device id in the query string
export const setNativeAppDeviceId = (id) => {
	usingNativeAppId = true;
	deviceId = id;
	return deviceId;
};



// WEBPACK FOOTER //
// ./src/shared/util/deviceId.js